import { z } from "zod";
// Schema Zod - definisce le regole di validazione
export const ParsedEventSchema = z.object({
    isEvent: z.boolean(),
    confidence: z.number().min(0).max(100),
    title: z.string().nullable().optional(),
    description: z.string().nullable().optional(),
    startDate: z.string().nullable().optional(), // ISO 8601
    endDate: z.string().nullable().optional(), // ISO 8601
    location: z.string().nullable().optional(),
    organizer: z.string().nullable().optional(),
    eventType: z.string().nullable().optional(),
    categoryName: z.string().nullable().optional(),
});
//# sourceMappingURL=parsedEvent.js.map